import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchAllJobs, fetchAllLines, fetchAllTickets, fetchPreSignedUrl, fetchRerunJob, fetchServicesAll, fetchupdateToKanbanBoard } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import ToggleSwitch from "../shared/ToggleSwitch";

const IngestionFileLogs = ({ fileName, bucketName, objectKey, responseKey }) => {
    const [showMoreColumns, setShowMoreColumns] = useState(false);
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(false)

    const { ref, inView } = useInView();

    const queryKey = ['backlog', fileName, decouncedSearchValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,

        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchInterval: autoRefreshEnabled ? 1000 * 3 : false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { fileName, lastEvaluatedKey: pageParam };

            if (decouncedSearchValue) {
                params.lineNumber = decouncedSearchValue
            }

            return fetchAllLines(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    // if (item.requestBody) {
                    //     try {
                    //         console.log(item.requestBody)
                    //         item.requestBodyParsed = JSON.parse(item.requestBody)
                    //     } catch (err) {
                    //         console.log(err)
                    //     }

                    // }
                    return item
                })).flatMap((x) => x), pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const resutls = data?.pages.flat()

    const items = data?.pages.flat();

    let columns = ['pk', 'lineNumber']
    //const columns = ['pk', 'status', 'errorMessage.message', 'count', 'startedAt', 'completedAt', 'duration'];

    if (objectKey?.includes('enrollments')) {
        columns = [...columns, 'responseBody.subscriberId', 'responseBody.enrollmentType', 'errorMessage.message', 'responseBody.status']
    } else if (objectKey?.includes('claimRepricing')) {
        columns = [...columns, 'responseBody.hccClaimNumber', 'responseBody.attachmentSetId', 'responseBody.claimState', 'errorMessage.message', 'responseBody.failures.failure.failureType', 'responseBody.status',]
    } else if (objectKey?.includes('rematchClaim')) {
        columns = [...columns, 'responseBody.ClaimDetailsResponse[0].hccClaimNumber', 'responseBody.ClaimDetailsResponse[0].errors.error[0].message', 'responseBody.ClaimDetailsResponse[0].status',]
    } else if (objectKey?.includes('claims')) {
        columns = [...columns, 'requestBody.externalClaimNumber', 'responseBody.hccClaimNumber', 'responseBody.claimIdentifier', 'errorMessage.message', 'responseBody.status',]
    } else if (objectKey?.includes('authorization')) {
        columns = [...columns, 'responseBody.authorizationId', 'responseBody.authorizationInternalId', 'responseBody.externalAuthorizationId', 'responseBody.memberId', 'responseBody.authorizationStatus', 'errorMessage.message', 'responseBody.transactionInformation.exceptions.messageDescription', 'responseBody.status',]
    } else if (objectKey?.includes('accumulator')) {
        columns = [...columns, 'requestBody.targetId.memberHccId', 'requestBody.firstName', 'requestBody.lastName', 'responseBody.accumulatorAdjustmentIdentifier', 'responseBody.operationType', 'responseBody.accumulatorName', 'responseBody.description', 'responseBody.accumValue.money', 'errorMessage.message', 'responseBody.Status']
    }

    if (showMoreColumns) {
        columns = [
            ...columns,
            'createdAt',
            'updatedAt'

        ];
    }
    // columns.push('responseBody.transactionInformation.exceptions')
    //  const columns = ['pk', 'lineNumber', 'responseBody.status', 'responseBody.failures.failure.message', 'errorMessage.message'];

    const downloadFile = async ({ bucketName, objectKey }) => {
        const res = await fetchPreSignedUrl({ bucketName, objectKey });
        window.open(res.signedUrl, "_blank");
        return

    }

    const { isPending: isObjectKeyPending, data: signedUrlData } = useQuery({
        queryKey: ['downloadOriginalObject', bucketName, objectKey],
        queryFn: () => fetchPreSignedUrl({ bucketName, objectKey }),
        enabled: !!(bucketName && objectKey)
    })

    const { isPending: isResponseKeyPending, data: signedUrlLogData } = useQuery({
        queryKey: ['downloadLogObject', bucketName, responseKey],
        queryFn: () => fetchPreSignedUrl({ bucketName, objectKey: responseKey }),
        enabled: !!(bucketName && responseKey)
    })

    const rerunJob = async ({ bucketName, objectKey }) => {
        if (confirm(`Are you sure you want to rerun the Job ${objectKey} ?`)) {
            console.log('Job scheduled.');
            return await fetchRerunJob({ bucketName, objectKey })
        }


    }

    return (
        <div className="container">

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <p className="title">Ingestion</p>
                    <p className="sub-title">Edi to HRP ingestion</p>

                    {/* <p className="clickable-link" onClick={async () => await downloadFile({ bucketName, objectKey })}>Download file</p> */}
                    <div style={{ padding: '.4rem 0rem', display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
                        {((objectKey && isObjectKeyPending) || (responseKey && isResponseKeyPending)) && <div className="loader" />}
                        {signedUrlData && <a href={signedUrlData.signedUrl} target="_blank">{objectKey}</a>}
                        {signedUrlLogData && <a href={signedUrlLogData.signedUrl} target="_blank">{responseKey}</a>}
                    </div>

                    {!objectKey?.includes('accumulator') && <button onClick={async () => await rerunJob({ bucketName, objectKey })}>Re run job</button>}

                </div>

                <div>
                    <ToggleSwitch
                        label={`Auto Refresh`}
                        onToggle={(val) => setAutoRefreshEnabled(val)}
                        initialState={autoRefreshEnabled}
                    />
                </div>
            </div>




            {/* {lastUpdatedAt} */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="number"
                        id={"search"}
                        placeholder="Line number"
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p></p>
                {/* <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {

                        setSelectedSearchOption(null)
                        setSelectedDate(null);
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p> */}

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"edi-ingestion-lines"}
                        columns={columns}
                        items={items}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}


        </div>
    )
}

export default IngestionFileLogs